import { motion } from 'framer-motion';

const partners = ['DLF Limited', 'Godrej Properties', 'Lodha Group', 'Oberoi Realty', 'Prestige Group', 'Brigade Group', 'Sobha Limited', 'Hiranandani Group', 'The Phoenix Mills', 'Tata Housing', 'Shapoorji Pallonji', 'HOABL'];

const Partners = () => {
  return (
    <section id="partners" className="overflow-hidden bg-[#F5F5F5] py-24 sm:py-32" data-testid="partners-section">
      <div className="mx-auto max-w-7xl px-4 sm:px-6 lg:px-8">
        <motion.div initial={{ opacity: 0, y: 28 }} whileInView={{ opacity: 1, y: 0 }} viewport={{ once: true }} transition={{ duration: 0.7 }} className="mb-14 flex flex-col gap-6 lg:flex-row lg:items-end lg:justify-between">
          <div>
            <div className="mb-5 font-tech text-xs uppercase tracking-[0.28em] text-[#C5A880]">Developer bench</div>
            <h2 className="max-w-2xl font-display text-3xl font-semibold leading-tight tracking-tight text-[#0B1F3B] sm:text-4xl">The names buyers already trust.</h2>
          </div>
          <p className="max-w-xl text-base leading-relaxed text-[#0B1F3B]/65">Mandate relationships across India’s strongest residential and plotted development brands.</p>
        </motion.div>
      </div>

      <div className="border-y border-[#0B1F3B]/10 py-7" data-testid="developer-marquee">
        <div className="marquee-track">
          {[...partners, ...partners].map((partner, index) => (
            <div key={`${partner}-${index}`} className="flex shrink-0 items-center gap-8 px-8">
              <span className="font-display text-3xl font-semibold tracking-tight text-[#0B1F3B] sm:text-4xl">{partner}</span>
              <span className="font-display text-2xl text-[#C5A880]">✦</span>
            </div>
          ))}
        </div>
      </div>

      <div className="mx-auto mt-14 max-w-7xl px-4 sm:px-6 lg:px-8">
        <div className="grid gap-4 sm:grid-cols-3">
          {[
            ['12+', 'Tier-one developers'],
            ['50+', 'Inventory closures'],
            ['Pan-India', 'Mandate coverage'],
          ].map(([value, label], index) => (
            <motion.div key={label} initial={{ opacity: 0, y: 24 }} whileInView={{ opacity: 1, y: 0 }} viewport={{ once: true }} transition={{ duration: 0.55, delay: index * 0.08 }} className="rounded-3xl border border-[#0B1F3B]/10 bg-white p-6 text-center shadow-sm" data-testid={`partner-stat-${index + 1}`}>
              <div className="font-display text-4xl font-semibold text-[#0B1F3B]">{value}</div>
              <div className="mt-2 font-tech text-[11px] uppercase tracking-[0.2em] text-[#0B1F3B]/50">{label}</div>
            </motion.div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default Partners;
